module.exports = __webpack_public_path__ + "img/vanilla-verve.3683715a.svg";